var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageBillingHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 5.50065H14.667M7.33366 9.16732H14.667M7.33366 12.834H14.667M5.50033 1.83398H16.5003C17.5128 1.83398 18.3337 2.6548 18.3337 3.66732V17.2009C18.3337 18.5638 16.8994 19.4502 15.6804 18.8407L15.4869 18.7439C14.9708 18.4859 14.3632 18.4859 13.8471 18.7439L11.8202 19.7574C11.3041 20.0154 10.6966 20.0154 10.1804 19.7574L8.15355 18.7439C7.63742 18.4859 7.0299 18.4859 6.51377 18.7439L6.32022 18.8407C5.10123 19.4502 3.66699 18.5638 3.66699 17.2009V3.66732C3.66699 2.6548 4.4878 1.83398 5.50033 1.83398Z",
    stroke: "#2828F0",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBillingHistory);
export default __webpack_public_path__ + "static/media/pageBillingHistory.1dccbc646908d735a2451af47af12c5c.svg";
export { ForwardRef as ReactComponent };